export default __webpack_public_path__ + "static/media/1111946.36f358ea.jpeg";